module.exports = __webpack_public_path__ + "fonts/Inter-700-cyrillic47.fbe36d9.woff2";